import { render, staticRenderFns } from "./UserSearchJobs.vue?vue&type=template&id=201639b6&scoped=true"
import script from "./UserSearchJobs.vue?vue&type=script&lang=js"
export * from "./UserSearchJobs.vue?vue&type=script&lang=js"
import style0 from "./UserSearchJobs.vue?vue&type=style&index=0&id=201639b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201639b6",
  null
  
)

export default component.exports